<template>
  <b-card
      v-if="data"
      no-body
      class="card-statistics"
  >
    <!--    <b-card-header>-->
    <!--&lt;!&ndash;      <b-card-title>آمار</b-card-title>&ndash;&gt;-->
    <!--    </b-card-header>-->
    <b-card-body class="statistics-body">
      <b-row>
        <b-col
            xl="3"
            lg="3"
            md="6"
            sm="6"
            class="mb-1 cursor-pointer"
            @click="goTo('/agendas')"
        >
          <b-media no-body>
            <b-media-aside
                class="mr-2"
            >
              <b-avatar
                  size="48"
                  variant="light-info"
              >
                <feather-icon
                    size="24"
                    icon="TrelloIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ data.total }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                کل صورتجلسات
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col
            xl="3"
            lg="3"
            md="6"
            sm="6"
            class="mb-1 cursor-pointer"
            @click="goTo('/agendas')"
        >
          <b-media no-body>
            <b-media-aside
                class="mr-2"
            >
              <b-avatar
                  size="48"
                  variant="light-warning"
              >
                <feather-icon
                    size="24"
                    icon="MapIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ data.published }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                صورتجلسات نهایی
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col
            xl="3"
            lg="3"
            md="6"
            sm="6"
            class="mb-1 cursor-pointer"
            @click="goTo('/agendas')"
        >
          <b-media no-body>
            <b-media-aside
                class="mr-2"
            >
              <b-avatar
                  size="48"
                  variant="light-primary"
              >
                <feather-icon
                    size="24"
                    icon="CheckIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ data.draft }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                صورتجلسات پیش نویس
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col
            xl="3"
            lg="3"
            md="6"
            sm="6"
            class="mb-1 cursor-pointer"
            @click="goTo('/agendas')"
        >
          <b-media no-body>
            <b-media-aside
                class="mr-2"
            >
              <b-avatar
                  size="48"
                  variant="light-primary"
              >
                <feather-icon
                    size="24"
                    icon="CheckIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ data.canceled }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                جلسات لغو شده
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  props: {
    data: {
      type: Object,
      default: () => {
      },
    },
  },
  methods: {
    goTo(path, params) {
      this.$router.push({
        path: path,
        query: params,
      })
    },
  },
}
</script>
